<template>
  <div>
    <div class="page-header">
      <h2>Tipificaciones</h2>
    </div>
    <div class="content-wrapper">
      <el-row>
        <el-col :sm="16">
          <div class="form-section">
            <el-steps :active="activeStep" finish-status="success" simple>
              <el-step title="Crear Tipificación"></el-step>
              <el-step title="Campos Adicionales"></el-step>
              <el-step title="Confirmar y Crear"></el-step>
            </el-steps>

            <el-form :model="tipificacionForm" :rules="rules" ref="tipificacionForm" label-position="top"
              class="tipificacion-form" size="small">
              <!-- Paso 1: Crear Tipificación -->
              <div v-show="activeStep === 0">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Tabla Origen" prop="tablaOrigen">
                      <el-select v-model="tipificacionForm.tablaOrigen" filterable placeholder="Seleccione la tabla"
                        style="width: 100%">
                        <el-option label="Recetas BOT" value="ttos_receta"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="Nombre" prop="nombre">
                      <el-input v-model="tipificacionForm.nombre" placeholder="Ingrese el nombre"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="Agente" prop="agente">
                      <el-select v-model="tipificacionForm.agente" filterable placeholder="Seleccione el agente"
                        style="width: 100%">
                        <el-option v-for="agente in agentes" :key="agente.id" :label="agente.id + ' - ' + agente.apodo"
                          :value="agente.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Canal" prop="canal">
                      <el-select v-model="tipificacionForm.canal" filterable placeholder="Seleccione el canal"
                        style="width: 100%">
                        <el-option label="App" value="app"></el-option>
                        <el-option label="Internal" value="internal"></el-option>
                        <el-option label="WhatsApp" value="whatsapp"></el-option>
                        <el-option label="Web" value="web"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Status" prop="status">
                      <el-select v-model="tipificacionForm.status" filterable placeholder="Seleccione el status"
                        style="width: 100%">
                        <el-option label="Open" value="open"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="Grupo de Atención" prop="grupoAtencion">
                      <el-select v-model="tipificacionForm.grupoAtencion" filterable placeholder="Seleccione el grupo"
                        style="width: 100%">
                        <el-option v-for="grupo in gruposAtencion" :key="grupo.id"
                          :label="grupo.id + ' - ' + grupo.name" :value="grupo.id">

                          <!-- <span style="float: left">{{ grupo.id }}</span>
                          <small style="float: right; color: gray;">{{ grupo.name }}</small> -->
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Tipificación" prop="tipificacion">
                      <el-select v-model="tipificacionForm.tipificacion" filterable disabled="true"
                        placeholder="Seleccione la tipificación" style="width: 100%">
                        <el-option v-for="tip in tipificaciones" :key="tip.id" :label="tip.id + ' - ' + tip.name"
                          :value="tip.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Etiqueta" prop="etiqueta">
                      <el-select v-model="tipificacionForm.etiqueta" multiple filterable
                        placeholder="Seleccione la etiqueta" style="width: 100%">
                        <el-option v-for="etiqueta in etiquetas" :key="etiqueta.name" :label="etiqueta.name"
                          :value="etiqueta.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Campo Cliente Validador" prop="campoValidador">
                      <el-select v-model="tipificacionForm.campoValidador" filterable
                        placeholder="Seleccione el campo validador" style="width: 100%">
                        <el-option v-for="campo in CamposCliente" :key="campo.id" :label="campo.original_name"
                          :value="campo.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Valor Validador" prop="valorValidador">
                      <el-select v-model="tipificacionForm.valorValidador" filterable placeholder="Seleccione el valor"
                        style="width: 100%">
                        <el-option v-for="valor in valoresValidador" :key="valor.columna" :label="valor.columna"
                          :value="valor.columna">


                          <span style="float: left">{{ valor.columna }}</span>
                          <small style="float: right; color: gray;">{{ valor.descripcion }}</small>

                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Contenido">
                  <el-input type="textarea" v-model="tipificacionForm.contenido" rows="1"></el-input>
                </el-form-item>
              </div>

              <!-- Paso 2: Campos Adicionales -->
              <div v-show="activeStep === 1">
                <div class="campos-adicionales">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <el-form-item label="Nombre de Campo del Ticket">
                        <el-select v-model="tipificacionForm.campoAdicional.nombre" filterable
                          placeholder="Seleccione el campo" style="width: 100%">
                          <el-option v-for="c1 in camposAdicionales" :key="c1.id" :label="c1.original_name"
                            :value="c1.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Valor del Campo">
                        <el-select v-model="tipificacionForm.campoAdicional.valor" filterable
                          placeholder="Seleccione el valor" style="width: 100%">
                          <el-option v-for="valor1 in valoresCampoAdicional" :key="valor1.columna" :label="valor1.columna"
                            :value="valor1.columna">
                            <span style="float: left">{{ valor1.columna }}</span>
                            <small style="float: right; color: gray;">{{ valor1.descripcion }}</small>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4" class="align-bottom">
                      <el-button type="primary" size="mini" @click="agregarCampoAdicional" style="margin-top: 34px;">Agregar
                        Campo</el-button>
                    </el-col>
                  </el-row>

                  <div v-if="tipificacionForm.camposAdicionalesCaso.length > 0" class="campos-agregados">
                    <el-table :data="tipificacionForm.camposAdicionalesCaso" size="small">
                      <el-table-column prop="nombre" label="Nombre de Campo"></el-table-column>
                      <el-table-column prop="valor" label="Valor"></el-table-column>
                      <el-table-column width="80">
                        <template slot-scope="scope">
                          <el-button type="danger" size="mini" icon="el-icon-delete" circle
                            @click="eliminarCampoAdicional(scope.$index)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <!-- Paso 3: Confirmar y Crear -->
              <div v-show="activeStep === 2">
                <div class="resumen-formulario">
                  <h3>Resumen de la Tipificación</h3>
                  <el-descriptions :column="2" border>
                    <el-descriptions-item label="Tabla Origen">{{ tipificacionForm.tablaOrigen }}</el-descriptions-item>
                    <el-descriptions-item label="Nombre">{{ tipificacionForm.nombre }}</el-descriptions-item>
                    <el-descriptions-item label="Agente">{{ obtenerNombreAgente(tipificacionForm.agente)
                      }}</el-descriptions-item>
                    <el-descriptions-item label="Canal">{{ tipificacionForm.canal }}</el-descriptions-item>
                    <el-descriptions-item label="Status">{{ tipificacionForm.status }}</el-descriptions-item>
                    <el-descriptions-item label="Grupo de Atención">{{
                      obtenerNombreGrupo(tipificacionForm.grupoAtencion) }}</el-descriptions-item>
                    <el-descriptions-item label="Tipificación">{{
  tipificacionForm.tipificacion }}</el-descriptions-item>
                    <el-descriptions-item label="Etiqueta">{{ tipificacionForm.etiqueta }}</el-descriptions-item>
                    <el-descriptions-item label="Campo Validador">{{ tipificacionForm.campoValidador
                      }}</el-descriptions-item>
                    <el-descriptions-item label="Valor Validador">{{ tipificacionForm.valorValidador
                      }}</el-descriptions-item>
                    <el-descriptions-item label="Contenido" :span="2">{{ tipificacionForm.contenido
                      }}</el-descriptions-item>
                  </el-descriptions>

                  <div v-if="tipificacionForm.camposAdicionalesCaso.length > 0" class="resumen-campos-adicionales">
                    <h4>Campos Adicionales</h4>
                    <el-table :data="tipificacionForm.camposAdicionalesCaso" size="small">
                      <el-table-column prop="nombre" label="Nombre de Campo"></el-table-column>
                      <el-table-column prop="valor" label="Valor"></el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <!-- Botones de navegación -->
              <div class="steps-action">
                <el-button v-if="activeStep > 0" @click="prevStep">Anterior</el-button>
                <el-button v-if="activeStep < 2" type="primary" @click="nextStep">Siguiente</el-button>
                <el-button v-if="activeStep === 2" type="success" @click="guardarTipificacion">Confirmar y
                  Crear</el-button>
              </div>
            </el-form>
          </div>
        </el-col>
        <el-col :sm="8">
          <div class="list-section">
            <h3>Tipificaciones Creadas</h3>
            <el-table :data="tipificacionesList" style="width: 100%" size="small">
              <el-table-column prop="nombre" label="Nombre"></el-table-column>
              <el-table-column prop="fecha" label="Fecha"></el-table-column>
              <el-table-column width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="verMas(scope.row)">Ver más</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { HTTP, V2 } from '@/axios'
import camposData from '@/assets/json/campos.json'
import agentesData from '@/assets/json/agentes.json'
import CamposClienteData from '@/assets/json/camposCliente.json'

export default {
    name: 'Tipificaciones',
    data() {
        return {
            activeStep: 0,
            camposValidador: [],
            gruposAtencion: [],
            tipificaciones: [],
            etiquetas: [],
            agentes: agentesData,
          CamposCliente: CamposClienteData,
            valoresValidador: [],
          camposAdicionales: [],
          camposAdicionalesCaso: [],
            valoresCampoAdicional: [],
            tipificacionesList: [],
            rules: {
                tablaOrigen: [
                    { required: true, message: 'Por favor seleccione la tabla origen', trigger: 'change' }
                ],
                nombre: [
                    { required: true, message: 'Por favor ingrese el nombre', trigger: 'blur' }
                ],
                agente: [
                    { required: true, message: 'Por favor seleccione el agente', trigger: 'change' }
                ],
                canal: [
                    { required: true, message: 'Por favor seleccione el canal', trigger: 'change' }
                ],
                status: [
                    { required: true, message: 'Por favor seleccione el status', trigger: 'change' }
                ],
                grupoAtencion: [
                    { required: true, message: 'Por favor seleccione el grupo de atención', trigger: 'change' }
                ],
                tipificacion: [
                    { required: false, message: 'Por favor seleccione la tipificación', trigger: 'change' }
                ],
                etiqueta: [
                    { required: true, message: 'Por favor seleccione la etiqueta', trigger: 'change' }
                ],
                campoValidador: [
                    { required: true, message: 'Por favor seleccione el campo validador', trigger: 'change' }
                ],
                valorValidador: [
                    { required: true, message: 'Por favor seleccione el valor validador', trigger: 'change' }
                ]
            },
            tipificacionForm: {
                nombre: '',
                canal: 'whatsapp',
                campoValidador: '',
                grupoAtencion: 26044,
                tipificacion: '',
                etiqueta: ['PRUEBA'],
                contenido: '',
                status: 'open',
                agente: 30420,
                tablaOrigen: 'ttos_receta',
                valorValidador: '',
                campoAdicional: {
                    nombre: '',
                    valor: ''
                },
                camposAdicionales: [],
                camposAdicionalesCaso: []
            }
        }
    },
    methods: {
        async nextStep() {
            try {
                if (this.activeStep === 0) {
                    await this.$refs.tipificacionForm.validate();
                }
                if (this.activeStep < 2) {
                    this.activeStep++;
                }
            } catch (error) {
                this.$message.error('Por favor complete todos los campos obligatorios');
                return;
            }
        },
        prevStep() {
            if (this.activeStep > 0) {
                this.activeStep--;
            }
        },
        obtenerNombreAgente(id) {
            const agente = this.agentes.find(a => a.id === id);
            return agente ? agente.nombre : '';
        },
        obtenerNombreGrupo(id) {
          if (this.gruposAtencion && this.gruposAtencion.length > 0) {
            const grupo = this.gruposAtencion.find(g => g.id === id);
            return grupo ? grupo.name : '';
          } else {
            return '';
          }
        },
        obtenerNombreTipificacion(id) {
            const tip = this.tipificaciones.find(t => t.id === id);
            return tip ? tip.nombre : '';
        },
        obtenerNombreEtiqueta(id) {
            const etiqueta = this.etiquetas.find(e => e.id === id);
            return etiqueta ? etiqueta.nombre : '';
        },
        obtenerNombreCampo(value) {
            const campo = this.camposValidador.find(c => c.value === value);
            return campo ? campo.label : '';
        },
      obtenerNombreValor(columna) {
          const valor = this.valoresValidador.find(v => v.columna === columna);
        return valor ? valor.columna : '';
        },
        async cargarDatos() {
            try {
                // Cargar datos de campos desde el JSON
                this.camposValidador = camposData;
                this.camposAdicionales = camposData;

                // Cargar datos de las APIs
                const [grupos, tipificaciones, etiquetas, valores] = await Promise.all([
                    this.obtenerGruposAtencion(),
                    this.obtenerTipificaciones(),
                    this.obtenerEtiquetas(),
                    this.obtenerValoresValidador()
                ]);

                this.gruposAtencion = grupos;
                this.tipificaciones = tipificaciones;
                this.etiquetas = etiquetas;
                this.valoresValidador = valores;
                this.valoresCampoAdicional = valores;

                // Cargar lista de tipificaciones
                this.cargarTipificaciones();
            } catch (error) {
                console.error('Error al cargar datos:', error);
                this.$message.error('Error al cargar los datos');
            }
        },
        async obtenerGruposAtencion() {
            // Implementar llamada a API
        
          try {
            const response = await HTTP.get(V2 + '/wise/groups');
            this.gruposAtencion = response.data.data;
           return response.data.data;
          } catch (error) {
            this.$message.error('Error al obtener los valores validadores');
            throw error;
          }
        },
        async obtenerTipificaciones() {
          try {
            const response = await HTTP.get(V2 + '/wise/types');
            this.tipificaciones = response.data.data;
            return response.data.data;
          } catch (error) {
            this.$message.error('Error al obtener los valores validadores');
            throw error;
          }
        },
        async obtenerEtiquetas() {
          try {
            const response = await HTTP.get(V2 + '/wise/tags');
            this.etiquetas = response.data.data;
            return response.data.data;
          } catch (error) {
            this.$message.error('Error al obtener los valores validadores');
            throw error;
          }
        },
        async obtenerValoresValidador() {
            try {
                const response = await HTTP.post(V2 + '/pruebas/table-structure', {
                    tablaOrigen: this.tipificacionForm.tablaOrigen
                });
                this.valoresValidador = response.data.data.columns;
              // console.log('obtenerValoresValidador',response.data.data.columns);
                return response.data.data.columns;
            } catch (error) {
                this.$message.error('Error al obtener los valores validadores');
                throw error;
            }
        },
        async cargarTipificaciones() {
            // Implementar llamada a API para obtener la lista
            this.tipificacionesList = [];
        },
        async guardarTipificacion() {
            try {
                // Implementar guardado
              console.log('guardarTipificacion', this.tipificacionForm);
                this.$message.success('Tipificación guardada exitosamente');
                this.cargarTipificaciones();
            } catch (error) {
                this.$message.error('Error al guardar la tipificación');
            }
        },
        agregarCampoAdicional() {
          console.log('agregarCampoAdicional', this.tipificacionForm.camposAdicionalesCaso);
            if (this.tipificacionForm.campoAdicional.nombre && this.tipificacionForm.campoAdicional.valor) {
              this.tipificacionForm.camposAdicionalesCaso.push({
                    nombre: this.tipificacionForm.campoAdicional.nombre,
                    valor: this.tipificacionForm.campoAdicional.valor
                });
                this.tipificacionForm.campoAdicional.nombre = '';
                this.tipificacionForm.campoAdicional.valor = '';
            }else{
              this.$message.error('Por favor seleccione el campo y el valor');
            }
        },
        eliminarCampoAdicional(index) {
          this.tipificacionForm.camposAdicionalesCaso.splice(index, 1);
        },
        verMas(row) {
            // Implementar lógica para ver más detalles
        }
    },
    mounted() {
      // this.obtenerValoresValidador()
        this.cargarDatos();
    }
}
</script>

<style lang="scss" scoped>
.page-header {
    padding: 13px;
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    
    h2 {
        margin: 0;
        color: #303133;
        font-size: 20px;
    }
}

.content-wrapper {
   
    height: calc(100vh - 80px);
}

.form-section {
    // flex: 16;
    background: #f1f1f1;
    padding: 20px;
    height: calc(100vh - 80px);
    overflow-y: auto;
}

.list-section {
    // flex: 8;
    background: #fff;
    padding: 0px;
    
    
    overflow-y: auto;

    h3 {
        margin-top: 0;
        margin-bottom: 20px;
        color: #303133;
          padding: 10px;
    }
}

.campos-adicionales {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #e6e6e6;

    h3 {
        margin-top: 0;
        margin-bottom: 20px;
        color: #303133;
    }
}

.tipificacion-form {
    .el-form-item {
        margin-bottom: 20px;
    }

    .el-select {
        width: 100%;
    }
}

.campos-agregados {
    margin-top: 20px;
}

.align-bottom {
    display: flex;
    align-items: flex-end;
}

.steps-action {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.resumen-formulario {
    margin-top: 20px;

    h3 {
        margin-bottom: 20px;
        color: #303133;
    }

    h4 {
        margin: 20px 0;
        color: #606266;
    }
}

.resumen-campos-adicionales {
    margin-top: 20px;
}

:deep(.el-steps) {
    margin-bottom: 30px;
}
</style> 